/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * LookupsApi - axios parameter creator
 * @export
 */
export const LookupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Look up the business entity name from an ABN
         * @param {string} abn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNumberLookupControllerLookupAbn: (abn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'abn' is not null or undefined
            assertParamExists('businessNumberLookupControllerLookupAbn', 'abn', abn);
            const localVarPath = `/business-number-lookup/au/{abn}`.replace(`{${'abn'}}`, encodeURIComponent(String(abn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LookupsApi - functional programming interface
 * @export
 */
export const LookupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LookupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Look up the business entity name from an ABN
         * @param {string} abn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNumberLookupControllerLookupAbn(abn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.businessNumberLookupControllerLookupAbn(abn, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LookupsApi - factory interface
 * @export
 */
export const LookupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LookupsApiFp(configuration);
    return {
        /**
         *
         * @summary Look up the business entity name from an ABN
         * @param {string} abn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessNumberLookupControllerLookupAbn(abn, options) {
            return localVarFp
                .businessNumberLookupControllerLookupAbn(abn, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * LookupsApi - object-oriented interface
 * @export
 * @class LookupsApi
 * @extends {BaseAPI}
 */
export class LookupsApi extends BaseAPI {
    /**
     *
     * @summary Look up the business entity name from an ABN
     * @param {string} abn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LookupsApi
     */
    businessNumberLookupControllerLookupAbn(abn, options) {
        return LookupsApiFp(this.configuration)
            .businessNumberLookupControllerLookupAbn(abn, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
